<template>
  <div class="py-4 container-fluid">
      <div class="row p-0">
        <div class="col-12">
          <div class="multisteps-form pt-0 mt-0">
            <div class="row">
              <div class="col-lg-1 mx-auto">
                <div class="col-lg-12 p-0 text-start">
                      <a
                        class="p-0 back-button"
                        style="cursor: pointer"
                        :title="$t('key_button_back')"
                        @click="$router.go(-1)"
                      >
                        <i class="fa fa-arrow-circle-left" style="font-size: 35px;"></i>
                      </a>
                </div>
              </div>
              <div class="col-lg-9 p-0">
                <div class="multisteps-form__progress">
                  <button
                    class="multisteps-form__progress-btn js-active"
                    type="button"
                    :title="$t('key_pod_general_info')"
                    :class="activeStep >= 0 ? activeClass : ''"
                    @click="manifestId != null ? activeStep = 1 : activeStep = 0"
                  >
                    <span>{{ $t('key_pod_general_info') }}</span>
                  </button>
                  <button
                    class="multisteps-form__progress-btn"
                    type="button"
                    :title="$t('key_pod_files')"
                    :class="activeStep >= 1 ? activeClass : ''"
                    @click="manifestId == null ? activeStep = 0 : activeStep = 1"
                  >
                  {{ $t('key_pod_files') }}
                  </button>
                </div>
              </div>
              <div class="col-lg-2">
              </div>
            </div>
            <!--form panels-->
            <div class="row">
              <div class="col-lg-1">
              </div>
              <div class="col-lg-9 m-auto">
                <form class="multisteps-form__form mb-5">
                  <!--single form panel-->

                  <div class="multisteps-form__panel p-3" data-animation="FadeIn" :class="activeStep === 0 ? activeClass : ''">
                    <form ref='editManifestForm' class="needs-validation" novalidate>
                      <ManifestInfo @save='save'  />
                    </form>
                  </div>
                  <div class="multisteps-form__panel p-3" data-animation="FadeIn" :class="activeStep === 1 ? activeClass : ''">
                    <FileVisualizer v-if="manifestId != null" :manifest-id='manifestId'  />
                  </div>
                  <!--single form panel-->
                </form>
              </div>
              <div class="col-lg-2">
              </div>
            </div>
          </div>  
        </div>
      </div>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
  </div>
</template>

<script>
import { FileVisualizer } from "@/hotaka/components";
import SoftSnackbar from "@/components/SoftSnackbar.vue";
import ManifestInfo from "../components/ManifestInfo.vue";
export default {
  name: "EditManifest",
  components: {
    SoftSnackbar,
    ManifestInfo,
    FileVisualizer
  },
  data() {
    return {
      activeClass: "js-active position-relative text-primary",
      activeStep: 0,
      manifestId: null,
      notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
    }
  },
  computed: {
    newStatus(){
      return this.$store.state.manifiest.newManifest.status
    },
  },
  watch:{
    newStatus(newValue){
      if (newValue['created']) {
        const newManifest = this.$store.state.manifiest.newManifest.data
        this.manifestId = newManifest['_id']
        this.activeStep = 1
        this.showStatusNotification(newValue)
      }
      if (newValue['error']) {
        const { error: { error } } = newValue
        let message = this.$t('key_error_on_saving')
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Lo Sentimos',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },
  },
  methods: {
    save(manifest){
      let form = this.$refs.editManifestForm;
      if (form.checkValidity()) {
        this.$store.commit("manifiest/newManifest", manifest);
      }
      form.classList.add('was-validated')
    },
    closeNotification(){
      const self= this;
      setTimeout(function () {
          self.showNotification = false
      },3000);
    },
    showStatusNotification(){
      this.notificationInfo = {
        title: this.$t('key_pod_successfully_saved'),
        message: this.$t('key_pod_successfully_saved_message'),
        status: 'success'
      }
      this.showNotification = true;
      this.closeNotification();
    },
  },
};
</script>

<style lang="scss" scoped>

.noimageColorEdit{ 
  opacity: 0.1 !important;  
}

.picture-cursor {
  cursor: url('../../../assets/img/zoom-in.svg'), auto;
}

.cardimage {
  position: inherit !important;
}

.form-control:disabled{
  background-color: white;
  border: 1px solid transparent;
}

.noimageColor{ 
  opacity: 0.1 !important;
}

.back-button {
  color: #4A7062
}

.manifest-image {
  object-fit: contain;
  transition: transform .2s;
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
}
</style>

 